import React from "react";
import "../../../styles/forms.scss";
import { useTranslation } from "react-i18next";
import "./SalarialConditionPreview.scss";
import DisabledTextArea from "../../../../components/DisabledTextArea";
import SalaryPerLocationListPreview from "../../ViewInterview/AvailabilityAndConditions/SalaryPerLocationListPreview";

const SalarialConditionPreview = ({ interview }) => {
  const { t } = useTranslation();

  return (
    <form className="salary-condition form-group">
      <h1>{t("Salarial Condition")}</h1>
      <div className="salary-info">
        <div className="form-group">
          <label htmlFor="currentSalary">{t("Current Salary")}</label>
          <input
            type="number"
            className="form-control"
            placeholder="0,00€"
            id="currentSalary"
            name="currentSalary"
            value={parseFloat(
              interview.availabilityAndConditions.currentSalary
            )}
            disabled
          />
        </div>
        <div className="form-group type-contract-style">
          <label>{t("Currency")}</label>
          <select
            id="currentSalaryCurrencyId"
            name="currentSalaryCurrencyId"
            className="form-select"
            value={
              interview.availabilityAndConditions.currentSalaryCurrencyId || 1
            }
            disabled
          >
            <option>
              {interview.availabilityAndConditions.currentSalaryCurrency}
            </option>
          </select>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="currentSalaryValueIsLiquid"
            id="currentSalaryValueIsLiquid"
            defaultChecked
            checked={
              interview.availabilityAndConditions.currentSalaryValueIsLiquid
            }
            disabled
          />
          <label htmlFor="CurrentSalaryValueIsLiquid">{t("Liquid")}</label>
          <input
            className="form-check-input"
            type="radio"
            name="currentSalaryValueIsLiquid"
            id="currentSalaryValueIsNotLiquid"
            checked={
              interview.availabilityAndConditions.currentSalaryValueIsLiquid ===
              false
            }
            disabled
          />
          <label htmlFor="currentSalaryValueIsNotLiquid">{t("Gross")}</label>
        </div>
        <div className="form-group" style={{ marginLeft: "20px" }}>
          <label htmlFor="currentContract">{t("Current Contract")}</label>
          <select
            id="currentContract"
            name="currentContract"
            className="form-select"
            disabled
          >
            <option>
              {interview.availabilityAndConditions.currentContractType}
            </option>
          </select>
        </div>
      </div>
      <div className="custom-labels-container"></div>
      <div className="salary-info">
        <div className="form-group">
          <label htmlFor="currentSalary">{t("Salary Expected")}</label>
          <input
            type="number"
            className="form-control"
            placeholder="0,00€"
            id="salaryExpected"
            name="salaryExpected"
            value={interview.availabilityAndConditions.salaryExpected}
            disabled
          />
        </div>
        <div className="form-group type-contract-style">
          <label>{t("Currency")}</label>
          <select
            id="expectedSalaryCurrencyId"
            name="expectedSalaryCurrencyId"
            className="form-select"
            disabled
          >
            <option>
              {interview.availabilityAndConditions.expectedSalaryCurrency}
            </option>
          </select>
        </div>
        <div className="form-check">
          <input
            className="form-check-input"
            type="radio"
            name="salaryExpectedValueIsLiquid"
            id="salaryExpectedValueIsLiquid"
            defaultChecked
            checked={
              interview.availabilityAndConditions.salaryExpectedValueIsLiquid
            }
            disabled
          />
          <label htmlFor="SalaryExpectedValueIsLiquid">{t("Liquid")}</label>
          <input
            className="form-check-input"
            type="radio"
            name="salaryExpectedValueIsLiquid"
            id="salaryExpectedValueIsNotLiquid"
            checked={
              interview.availabilityAndConditions
                .salaryExpectedValueIsLiquid === false
            }
            disabled
          />
          <label htmlFor="SalaryExpectedValueIsNotLiquid">{t("Gross")}</label>
        </div>
        <div className="form-group" style={{ marginLeft: "20px" }}>
          <label htmlFor="desiredContractType">
            {t("Desired Contract Type")}
          </label>
          <select
            id="expectedContract"
            name="expectedContract"
            className="form-select"
            disabled
          >
            <option>
              {interview.availabilityAndConditions.expectedContractType}
            </option>
          </select>
        </div>
      </div>
      <SalaryPerLocationListPreview
        interview={interview}
      />
      <div className="form-group">
        <label htmlFor="SalarialInformation">{t("Salary Information")}</label>
        <DisabledTextArea
          id="salarialInformation"
          name="salarialInformation"
          value={interview.availabilityAndConditions.salarialInformation}
          placeholder={t("Information about salary...")}
        />
      </div>
    </form>
  );
};

export default SalarialConditionPreview;